import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import PrimaryButton from '../button/PrimaryButton';
import SecondaryButton from '../button/SecondaryButton';

interface DeleteConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" id="delete-test-dialog">
            <DialogContent>
                <DialogContentText className="!mt-4 !font-inter !text-[000] !text-[14px] !text-primary-grey">
                    Are you sure you want to delete this test?
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center', marginBottom:"15px" }}>
                <PrimaryButton addStyle="!w-[62px] !h-[36px]" onClick={onConfirm}>Yes</PrimaryButton>
                <SecondaryButton onClick={onClose} addStyle="!w-[62px] !h-[36px]">No</SecondaryButton>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
